import { axiosInstance } from 'boot/axios'
// import QueryBuilder from 'src/utils/query-builder/query-builder'

export * from '../ms-base/actions'
/**
 * query motorcycles
 * @param {*} ctx
 * @param {*} params
 */
export async function queryMotorcycles(ctx, params) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/tyre-families/',
      method: 'get',
      params: params
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}
